// @flow
import React from 'react';
import { connect } from 'react-redux';

import { dispatch } from '../redux';

import { Form, Control, actions, Errors } from 'react-redux-form';
import { FormGroup } from 'react-bootstrap';
import ActionButton from './controls/ActionButton';

import {goToRoute, goToSubdomain} from '../utils/routing';

import * as signupFlowApi from '../api/signupFlow';

import ErrorContainer from './controls/ErrorContainer';

import ControlWrapper from './controls/ControlWrapper';

import { findOrgModal } from '../modals/FindOrgModal';

import { useFeatureflow } from 'react-featureflow-client';


function handleSubmit(values: any) {
  dispatch(actions.setPending('form.signup'));
  signupFlowApi.registerEmail(values.email, values.beta)
    .then(response=>{
      dispatch(actions.setPending('form.signup', false));
      return dispatch(actions.change('form.signup.once', response.once));
    }).then(()=>{
    goToRoute('/activate');
  }).catch((error)=>{
    dispatch(actions.setPending('form.signup', false));
    dispatch(actions.setErrors('form.signup', {
      submit: error
    }));
  });
}

function handleLoginSubmit(values: any) {
    dispatch(actions.setPending('form.login'));
    goToSubdomain(values.domain);
    dispatch(actions.setPending('form.login', false));
}


export default connect()(function(props: any): React.Element<any>{
  const featureflow = useFeatureflow();
  const signupRedirect = featureflow.evaluate('signup-redirect').isOn();
  const showAppLogin = featureflow.evaluate('app-login').isOn();
  
  return (


      <div>
        {signupRedirect ? (
          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: 12,
            padding: '32px 28px',
            marginBottom: 24,
            boxShadow: '0 8px 32px rgba(102, 126, 234, 0.3)',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: 48,
              marginBottom: 16
            }}>🚀</div>
            <h3 style={{
              color: 'white',
              fontWeight: 600,
              marginBottom: 12,
              fontSize: 22
            }}>
              Featureflow has evolved!
            </h3>
            <p style={{
              color: 'rgba(255, 255, 255, 0.9)',
              fontSize: 16,
              marginBottom: 20,
              lineHeight: 1.5
            }}>
              We've moved to a brand new platform with improved features and performance.
            </p>
            <a 
              href="https://app.featureflow.com" 
              style={{
                display: 'inline-block',
                background: 'white',
                color: '#667eea',
                padding: '12px 28px',
                borderRadius: 8,
                fontWeight: 600,
                fontSize: 16,
                textDecoration: 'none',
                boxShadow: '0 4px 14px rgba(0, 0, 0, 0.15)',
                transition: 'transform 0.2s, box-shadow 0.2s'
              }}
            >
              Go to app.featureflow.com →
            </a>
          </div>
        ) : (
          <Form
              model="form.signup"
              onSubmit={handleSubmit}
          >
              <ControlWrapper model=".email"
                              type="email"
                              label="Enter your email address"
                              placeholder="Email"
                              errorMessages={{
                                  isRequired: 'Please provide an email address.',
                                  isEmail: (val) => `${val} is not a valid email.`,
                              }}/>
              <FormGroup>
                  <Control component={ActionButton}
                           model="form.signup"
                           type="submit"
                           block
                           mapProps={{
                               disabled: props=>props.fieldValue.pending,
                               spinner: props=>props.fieldValue.pending
                           }}
                           bsStyle="success"
                  >
                      Sign up for free
                  </Control>
              </FormGroup>
              <ErrorContainer>
                  <Errors model="form.signup"/>
              </ErrorContainer>
              <br/>
          </Form>
        )}

          <p>
              Already using Featureflow classic?
          </p>
          {showAppLogin &&
          <Form
              model="form.login"
              onSubmit={handleLoginSubmit}
          >
              <p>Enter your domain. <small>(e.g. <i>domain</i>.featureflow.io)</small></p>
              <ControlWrapper model=".domain"
                              type="text"
                              placeholder="Domain"
                              errorMessages={{
                                  isRequired: 'Please enter your domain.'
                              }}/>
              <FormGroup>
                  <Control component={ActionButton}
                           model="form.login"
                           type="submit"
                           block
                           mapProps={{
                               disabled: props => props.fieldValue.pending,
                               spinner: props => props.fieldValue.pending
                           }}

                           className="btn-outline-primary"
                  >
                      Login
                  </Control>
              </FormGroup>
              <ErrorContainer>
                  <Errors model="form.login"/>
              </ErrorContainer>
              <br/>
          </Form>
          }

          <p>
              <button className="link-button" onClick={()=>{
                  findOrgModal()
              }}>Find your organisation</button>
          </p>

      </div>


  )
});